import { MockedResponse } from "@apollo/client/testing";
import { APPLICATION_SETTINGS } from "./get-application-settings";
import { GetAppSettingsQuery, SupportedLanguages } from "gql/graphql";

export const GET_APPLICATION_SETTINGS_MOCK: MockedResponse<GetAppSettingsQuery> =
  {
    request: {
      query: APPLICATION_SETTINGS,
    },
    maxUsageCount: Infinity,
    delay: 2000,
    variableMatcher: () => true,
    result: {
      data: {
        getApplicationSettings: {
          companyName: "master",
          mainColor: "#3467b2",
          accentColor: null,
          languages: [SupportedLanguages.En, SupportedLanguages.Ru],
          logo: {
            link: "/backend/files?file=s3%3A%2F%2F2024%2F05%2F16%2F5e9bdef1%2D9aa7%2Da998%2Dfbf1%2Dfe1d5bbd1e71%2Epng%3Fname%3D%25D0%25A1%25D0%25BD%25D0%25B8%25D0%25BC%25D0%25BE%25D0%25BA%2B%25D1%258D%25D0%25BA%25D1%2580%25D0%25B0%25D0%25BD%25D0%25B0%2B2024%2D04%2D22%2B%25D0%25B2%2B11%2E15%2E41%2Epng%26hash%3D0c1612befab8f5508ccd362136c28530",
            __typename: "FileDto",
          },
          __typename: "ApplicationSettingsDto",
        },
      },
    },
  };
